import { Type } from '@angular/core';
import { CalculatedFieldComponent } from '../formly/fields/calculated/view';
import { CheckboxGroupFieldComponent } from '../formly/fields/checkbox-group/view/checkbox-group-field.component';
import { CheckboxFieldComponent } from '../formly/fields/checkbox/view/checkbox-field.component';
import { ColorFieldComponent } from '../formly/fields/color/view/color-field.component';
import { DateTimeFieldComponent } from '../formly/fields/datetime/view/datetime-field.component';
import { DropdownFieldComponent } from '../formly/fields/dropdown/view/dropdown-field.component';
import { DurationFieldComponent } from '../formly/fields/duration/view/duration-field.component';
import { EmailFieldComponent } from '../formly/fields/email/view/email-field.component';
import { NumberFieldComponent } from '../formly/fields/number/view/number-field.component';
import { PhotoFieldComponent } from '../formly/fields/photo/view/photo-field.component';
import { RadioFieldComponent } from '../formly/fields/radio/view/radio-field.component';
import { SelectFieldComponent } from '../formly/fields/select/view/select-field.component';
import { TelFieldComponent } from '../formly/fields/tel/view/tel-field.component';
import { TextLabelFieldComponent } from '../formly/fields/text-label/view/text-label-field.component';
import { InputFieldComponent } from '../formly/fields/text/view/input-field.component';
import { TextareaFieldComponent } from '../formly/fields/textarea/view/textarea-field.component';
import { ToggleFieldComponent } from '../formly/fields/toggle/view/toggle-field.component';

/**
 * Centralized field type registry — the single source of truth for which
 * Formly view components are registered for which type name.
 *
 * This configuration is used by:
 * - app.config.ts: to register Formly field types via getFormlyTypes()
 *
 * A future app adding a new field type should register it here rather than
 * inline in app.config.ts, so this stays the one place that lists them.
 */
export interface FieldTypeConfig {
  name: string;
  viewComponent: Type<any>;
}

export const FIELD_TYPES: FieldTypeConfig[] = [
  { name: 'calculated', viewComponent: CalculatedFieldComponent },
  { name: 'text', viewComponent: InputFieldComponent },
  { name: 'datetime', viewComponent: DateTimeFieldComponent },
  { name: 'duration', viewComponent: DurationFieldComponent },
  { name: 'textarea', viewComponent: TextareaFieldComponent },
  { name: 'number', viewComponent: NumberFieldComponent },
  { name: 'email', viewComponent: EmailFieldComponent },
  { name: 'tel', viewComponent: TelFieldComponent },
  { name: 'checkbox', viewComponent: CheckboxFieldComponent },
  { name: 'color', viewComponent: ColorFieldComponent },
  { name: 'toggle', viewComponent: ToggleFieldComponent },
  { name: 'radio', viewComponent: RadioFieldComponent },
  { name: 'checkbox-group', viewComponent: CheckboxGroupFieldComponent },
  { name: 'select', viewComponent: SelectFieldComponent },
  { name: 'dropdown', viewComponent: DropdownFieldComponent },
  { name: 'photo', viewComponent: PhotoFieldComponent },
  { name: 'text-label', viewComponent: TextLabelFieldComponent },
];

/**
 * Get Formly type definitions for all field types.
 * Used to register field types with Formly in the application configuration.
 */
export function getFormlyTypes(): Array<{ name: string; component: Type<any> }> {
  return FIELD_TYPES.map((ft) => ({
    name: ft.name,
    component: ft.viewComponent,
  }));
}
